import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export function Reveal({ children, delay = 0, y = 28, className = "", testId }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.8, delay, ease: EASE }}
      data-testid={testId}
    >
      {children}
    </motion.div>
  );
}

export function SectionHeading({ eyebrow, title, sub, testId }) {
  return (
    <Reveal testId={testId} className="max-w-2xl">
      {eyebrow && <p className="eyebrow">{eyebrow}</p>}
      <h2 className="mt-4 font-display text-2xl font-bold uppercase tracking-tight text-white sm:text-3xl lg:text-4xl">
        {title}
      </h2>
      {sub && <p className="mt-4 text-base leading-relaxed text-neutral-400 sm:text-lg">{sub}</p>}
    </Reveal>
  );
}